import { AnimatePresence, motion } from 'framer-motion'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { IconButton } from '../Common/IconButton'
import type { ProactiveSuggestionPayload } from '../../types/ai'
import { useNls } from '../../nls/nlsProvider'

export const ProactiveSuggestionTray = ({
  suggestions,
  onAccept,
  onSnooze,
}: {
  suggestions: ProactiveSuggestionPayload[]
  onAccept: (suggestion: ProactiveSuggestionPayload) => void
  onSnooze: (suggestionId: string) => void
}) => {
  const { t } = useNls()
  return (
    <AnimatePresence initial={false}>
      {suggestions.map((suggestion) => {
        const kind = suggestion.kind === 'GAP_ANALYSIS' ? t('NLSAiSuggestionGapAnalysis') : t('NLSAiSuggestionPastContext')
        return (
          <motion.aside
            key={suggestion.id}
            className="lineSuggestionCard"
            aria-label={t('NLSAiSuggestionAria', { kind })}
            initial={{ opacity: 0, y: 8, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 4, scale: 0.98 }}
          >
            <span className="lineSuggestionKind">{kind}</span>
            <span>{suggestion.message}</span>
            <div className="lineSuggestionActions">
              <IconButton
                size="sm"
                variant="tertiary"
                label={t('NLSAiActionSnoozeSuggestion')}
                onClick={() => onSnooze(suggestion.id)}
                icon={<CloseRoundedIcon fontSize="inherit" />}
              />
              <IconButton
                size="sm"
                variant="secondary"
                label={t('NLSAiActionAcceptSuggestion')}
                onClick={() => onAccept(suggestion)}
                icon={<CheckRoundedIcon fontSize="inherit" />}
              />
            </div>
          </motion.aside>
        )
      })}
    </AnimatePresence>
  )
}
